<template>
    <div class="aside nav" :class="menuClass" style="margin-top: -49px;">

      <li style="cursor:pointer">
        <router-link
          tag="li"
          class="menu-header"
          :to="{path: homeDashboard[this.$store.state.positionStation]}"
          @click.native="setBreadcrumb2()"
        >
          <Icon  type="ios-home" size="24" class="icon nav-icon" style="margin-right: 4px;color: #ebc668;"></Icon>
          <span class="titleMenu">首页</span>
        </router-link>
      </li>
        <ul class="menuList">
            <li
                class="nav-item"
                :class="{'nav-show': m.state}"
                v-for="m in carte"
                :id="m.id"
                :key="m.id"
            >
                <template v-if="m.children">
                    <a @click="toggle(m)">
                        <Icon
                            class="nav-icon"
                            :type="m.icon"
                        ></Icon>
                        <span>{{m.text}}</span>
                        <Icon
                            class="nav-more"
                            :type="m.state ? 'ios-arrow-down' : 'ios-arrow-forward'"
                        />
                    </a>
                    <ul>
                        <li
                            class="level2"
                            :class="{'mm-show': mm.state}"
                            v-for="mm in m.children"
                            :key="mm.id"
                            ref="level2"
                        >
                            <template v-if="mm.children">
                                <a @click="togLevel3(mm)">
                                    <span>{{mm.text}}</span>
                                    <Icon
                                        class="nav-more"
                                        :type="mm.state ? 'ios-arrow-down' : 'ios-arrow-forward'"
                                    />
                                </a>
                                <ul>
                                    <li
                                        v-for="n in mm.children"
                                        :key="n.id"
                                        class="level3"
                                    >
                                        <router-link v-if="!isHttp(n.url)" :to="n.url || '/'" @click.native="setBreadcrumb(m,mm,n)">
                                            <span>
                                                {{n.text}}
                                            </span>
                                        </router-link>
                                    </li>
                                </ul>
                            </template>
                            <router-link
                                v-else-if="!isHttp(mm.url)"
                                :to="mm.url || '/'"
                                @click.native="setBreadcrumb(m,mm)"
                            >
                                <span>
                                    {{mm.text}}
                                </span>
                            </router-link>
                            <a :href="m.url" v-else target="_blank">
                                <Icon
                                    class="nav-icon"
                                    :type="m.icon"
                                ></Icon>
                                <span>
                                    {{m.text}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </template>
                <router-link
                    v-else-if="!isHttp(m.url)"
                    :to="m.url || '/'"
                    @click="toggle(m)"
                >
                    <Icon
                        class="nav-icon"
                        :type="m.icon"
                    ></Icon>
                    <span>
                        {{m.text}}
                    </span>
                </router-link>
                <a :href="m.url" v-else target="_blank">
                    <Icon
                        class="nav-icon"
                        :type="m.icon"
                    ></Icon>
                    <span>
                        {{m.text}}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import {
  queryMenus,
  querySubMenus,
} from '@/api/menus'

export default {
  name: 'Menu',
  data() {
    return {
      routes: {},
      // carte: [],
      expand: true,
      homeDashboard: {
        'superadmin': '/dashboard',
        'apply': '/enterprisepage',
        'gr': '/personalpage',
        'info': '/ditwopage',
        'other': '/otherpage',
        'fws': '/serviceprovider',
        'yh': '/YHPage',
        'mang': '/ZFJGPage',
        'dbjg': '/BondCompanyPage',
        'zfcg': '/czcgpage',
        'jjglr': '/cjythreepage',
        'sczj': '/cjythreepage',
        'yjj': '/cjythreepage'
      }
    }
  },

  computed: {
    ...mapState({
      size: 'size',
    }),

    menuClass() {
      return {
        'nav-mini': !this.expand,
      }
    },

    carte() {
      return this.$store.state.menuList
    },
  },

  methods: {
    isHttp(url) {
      return !url || url.indexOf('http') === 0
    },

    reload() {
      this.getMenus()
    },

    toggle(menu) {
      const state = menu.state
      console.log(this.carte)
      this.carte.forEach(m => {
        this.$set(m, 'state', false)
      })
      this.$set(menu, 'state', !state)
    },

    togLevel3(menu) {
      const state = menu.state;
      this.carte.forEach(m => {
        m.children.forEach(n => {
          this.$set(n, 'state', false)
        })
      })
      this.$set(menu, 'state', !state)
    },
    setBreadcrumb(...arr) {
      localStorage.setItem('breadcrumbList', JSON.stringify(arr))
    },
    setBreadcrumb2() {
      const temp = {'text': '首页', 'icon': 'ios-home', 'url': this.homeDashboard[this.$store.state.positionStation]}
      this.setBreadcrumb(temp)
    },

    getRoute(id) {
      return this.routes[id] || {}
    },

    async getMenus(sub) {
      sub = sub || this.$route.query.menu
      let carte = []
      if (!sub) {
        carte = await queryMenus()
      } else {
        carte = await querySubMenus(sub)
      }

      if (carte[0]) {
        this.$set(carte[0], 'state', true)
      }
      this.$store.commit('setMenuList', carte)

      let str = this.dealMenuPathList(carte)
      if (str === '') {
        this.$store.commit('setMenuPathList', [])
      } else {
        this.$store.commit('setMenuPathList', str.split(';'))
      }
    },
    dealMenuPathList(menuList) {
      let str = ''
      menuList.forEach(p => {
        str = str + p.url + ';'
        if (p.children && p.children.length > 0) {
          str = str + this.dealMenuPathList(p.children)
        }
      })
      return str
    }
  },

  watch: {
    size(size) {
      this.expand = size !== 'small'
    }
  },

  mounted() {
    this.reload()
  }
}
</script>

<style scoped lang="less">
    .nav {
        width: 220px;
        height: 100%;
        background: #fff;
        transition: all .3s;
        font-size: 14px;
        user-select: none;
        .toggle {
            position: absolute;
            top: 50%;
            right: 300px;
            height: 64px;
            width: 18px;
            background: #263238;
            margin-top: -64px;
            border-radius: 0 4px 4px 0;
            transition: all .2s;
            cursor: pointer;
            opacity: 0;
        }
        ul.menuList {
            // max-height: e('calc(100vh - 64px)');
            height: calc(100vh - 120px);
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-track {
                width: 6px;
                background-color: #fff;
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb {
                width: 6px;
                border-radius: 3px;
                background-color: #c3c3c3;
            }
        }
        &:hover {
            .toggle {
                right: -18px;
                z-index: -1;
                opacity: 1;
            }
        }

        li {
            list-style: none;
        }

        a {
            display: block;
            overflow: hidden;
            padding-left: 20px;
            line-height: 50px;
            max-height: 50px;
            color: #333;
            transition: all .3s;
            text-decoration: none;

            span {
                margin-left: 36px;
                /*font-weight: bold;*/
            }
            i {
                color: #ebc668;
            }
        }

        .nav-item {
            position: relative;
            &>a>span {
                font-weight: bold;
                font-size: 15px;
            }
            ul {
                display: none;
                /*background: rgba(0, 0, 0, .1);*/
                background-color: #fff;

                // 第二层下面的菜单
                .level2 {
                    ul {
                        display: none;
                        .level3 {
                            // margin-left: 12px;
                            a {
                                color: #666;
                                text-indent: 14px;
                            }
                        }
                    }
                    &.mm-show {
                        ul {
                            display: block;
                        }
                        &>a {
                            background: #f4f4f4;
                        }
                    }
                    &>a {
                        // font-weight: bold;
                    }
                }
            }
            li>a:hover {
                color: #ebc668;
                background: #f4f4f4;
            }

            .nav-icon {
                font-size: 28px;
                position: absolute;
                margin-left: -1px;
                line-height: inherit;
            }

            .nav-more {
                float: right;
                margin-right: 20px;
                font-size: 12px;
                line-height: inherit;
                transition: transform .3s;
            }

            & > a:before {
                content: "";
                position: absolute;
                left: 0;
                width: 2px;
                height: 46px;
                background: #34A0CE;
                opacity: 0;
                transition: all .3s;
            }

            &.nav-show {
                border-bottom: none;
                background-color: #f0f0f0;
                ul {
                    display: block;
                }
            }

            // &.nav-show,
            & > a:hover,
            .router-link-exact-active {
                color: #ebc668;
                //background: #f4f4f4;
              background: inherit;
              background-color: rgba(240, 246, 255, 1);
              box-sizing: border-box;
              border-width: 3px;
              border-style: solid;
              border-color: #ebc668;
              border-left: 0px;
              border-top: 0px;
              border-bottom: 0px;
              border-radius: 0px;
              border-top-left-radius: 0px;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              border-bottom-left-radius: 0px;
              -moz-box-shadow: none;
              -webkit-box-shadow: none;
              box-shadow: none;
              font-family: '微软雅黑';
              font-weight: 400;
              font-style: normal;
              text-align: left
            }

            &.nav-show > a:before,
            & > a:hover:before,
            .router-link-exact-active {
                opacity: 1;
            }

        }

        &.nav-mini {
            // width: 60px;

            // a {
            //   padding-left: 17px;
            // }

            // .nav-item > a span {
            //   display: none;
            // }

            // .nav-more {
            //   margin-right: -20px;
            // }

            // .nav-item ul {
            //   position: absolute;
            //   top: 0;
            //   left: 60px;
            //   width: 180px;
            //   z-index: 99;
            //   background: #3C474C;
            //   overflow: hidden;
            // }

            // .nav-item:hover {
            //   background: rgba(255, 255, 255, .1);
            // }

            // .nav-item:hover .nav-item a {
            //   color: #FFF;
            // }

            // .nav-item:hover a:before {
            //   opacity: 1;
            // }

            // .nav-item.nav-show ul {
            //   display: none;
            // }
            // .nav-item:hover ul {
            //   display: block;
            // }
        }
        .menu-header{
            padding-left: 20px;
            height: 50px;
            line-height: 50px;
            color: #333;
            font-size: 15px;
            font-weight: bold;
        }
        .titleMenu{
            margin-left: 2px;
        }
    }
    .nav-item {
        display: none;
    }
</style>
